import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { PermissionsHttpClient } from '@omnea-app/permissions/permissionsHttpClient'
import type { paths } from '@omnea-app/permissions/permissionsHttpClient/permissionsGeneratedTypes'

type PermissionSetsResponse = paths['/permission-sets']['get']['responses'][200]['content']['application/json']
export type PermissionSetSummary = PermissionSetsResponse['permissionSets'][number]

export const PermissionSetsQueryKey = 'GetPermissionSets'

export const usePermissionSets = () => {
  const { getToken, user } = useAuthenticatedUser()
  return useQuery({
    queryKey: [PermissionSetsQueryKey, user.id],
    queryFn: async () => {
      const authorization = await getToken()
      const permissionsClient = new PermissionsHttpClient({ authorization })
      const { data, error } = await permissionsClient.GET('/permission-sets')
      throwIfApiError(error)
      return data
    },
  })
}
